import {  Routes } from '@angular/router';
// import { BuyAnotherMembershipComponent } from './pages/tlcComponents/tabs-membership/buy-another-membership/buy-another-membership.component';
import { CertificateCountDetailsComponent } from './pages/tlcComponents/tabs-membership/certificate-count-details/certificate-count-details.component';
import { AuthGuard } from './guard/auth.guard';
// import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { CardWalletComponent } from './pages/tlcComponents/tabs-membership/card-wallet/card-wallet.component';

export const routes: Routes = [

  {
    path: '',
    loadComponent: () => import("./pages/welcome/welcome.page").then(m => m.WelcomePage),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'hotels-and-resorts',
  //   loadComponent: () => import("./pages/welcome/welcome.page").then(m => m.WelcomePage),
  //   // canActivate: [AuthGuard]
  // },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'activate-membership',
    loadComponent:() => import('./pages/activate-membership/activate-membership.page').then(m => m.ActivateMembershipPage)

  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
  {
    path: 'membership-home',
    loadComponent: () => import('./pages/membership-home/membership-home.page').then(m => m.MembershipHomePage),
  },
  // {
  //   path: 'set-up-profile',
  //   loadComponent: () => import('./pages/set-up-profile/set-up-profile.page').then(m => m.SetUpProfilePage)
  // },
  {
    path: 'privacy-statement',
    loadComponent: () => import('./pages/privacy-statement/privacy-statement.page').then(m => m.PrivacyStatementPage)
  },
  // {
  //   path: 'register-user',
  //   loadComponent: () => import('./pages/signUp/register-user/register-user.page').then(m => m.RegisterUserPage)
  // },
  {
    path: 'enroll-for-property',
    loadComponent: () => import('./pages/signUp/enroll-for-property/enroll-for-property.page').then(m => m.EnrollForPropertyPage)
  },
  {
    path: 'spouse-membership',
    loadComponent: () => import('./pages/spouse-membership/spouse-membership.page').then(m => m.SpouseMembershipPage)
  },
  {
    path: 'search-outlet',
    loadComponent: () => import('./pages/search-outlet/search-outlet.page').then(m => m.SearchOutletPage)
  },
  {
    path: 'book-a-table',
    loadComponent: () => import('./pages/search-outlet/search-outlet.page').then(m => m.SearchOutletPage)
  },
  {
    path: 'refer-friend',
    loadComponent: () => import('./pages/refer-friend/refer-friend.page').then(m => m.ReferFriendPage)
  },
  {
  path: 'tabs',
  loadChildren: () => import('./pages/tabs/tabs.routes').then(m => m.tabsRoutes),
  },
  {
    path: 'refer-status',
    loadComponent: () => import('./pages/refer-status/refer-status.page').then(m => m.ReferStatusPage)
  },
  // {
  //   path: 'customise-experience',
  //   loadComponent: () => import('./pages/customise-experience/customise-experience.page').then(m => m.CustomiseExperiencePage)
  // },
  {
    path: 'outlet-details',
    loadComponent: () => import('./pages/outlet-details/outlet-details.page').then(m => m.OutletDetailsPage)

  },
  {
    path: 'buy-certificates',
    loadComponent:() => import('./pages/buy-certificates/buy-certificates.page').then(m => m.BuyCertificatesPage)
  },
  {
    path: 'unique-experiences',
    loadComponent: () => import('./pages/unique-experiences/unique-experiences.page').then(m => m.UniqueExperiencesPage)
  },
  {
    path: 'membership-benfits',
    loadComponent: () => import('./pages/membership-benfits/membership-benfits.page').then(m => m.MembershipBenfitsPage)
  },
  // {
  //   path: 'unlock-benefits',
  //   loadComponent: () => import('./pages/unlock-benefits/unlock-benefits.page').then(m => m.UnlockBenefitsPage)
  // },
  {
    path: 'certificates-list',
    loadComponent:() => import('./pages/certificates-list/certificates-list.page').then(m => m.CertificatesListPage)
  },
  {
    path: 'certificate-detail',
    loadComponent:() => import('./pages/certificate-detail/certificate-detail.page').then(m => m.CertificateDetailPage)
  },
  // {
  //   path: 'cart',
  //   loadComponent:() => import('./pages/cart/cart.page').then(m => m.CartPage)
  // },
  {
    path: 'gift-membership',
    loadComponent:() => import('./pages/gift-membership/gift-membership.page').then(m => m.GiftMembershipPage)
  },
  {
    path: 'gift-details',
    loadComponent:() => import('./pages/gift-details/gift-details.page').then(m => m.GiftDetailsPage)
  },
  {
    path: 'gift-certificates',
    loadComponent: () => import('./pages/gift-certificates/gift-certificates.page').then(m => m.GiftCertificatesPage)
  },
  // {
  //   path: 'gift-cert-success',
  //   loadComponent:() => import('./pages/gift-cert-success/gift-cert-success.page').then(m => m.GiftCertSuccessPage)
  // },
  // {
  //   path: 'offers-and-events',
  //   loadComponent: () => import('./pages/offers-and-events/offers-and-events.page').then(m => m.OffersAndEventsPage)
  // },
  // {
  //   path: 'checkout',
  //   loadComponent: () => import('./pages/checkout/checkout.page').then(m => m.CheckoutPage)
  // },
  // {
  //   path: 'activities-hub',
  //   loadComponent: () => import('./pages/plan-with-club/activities-hub/activities-hub.page').then(m => m.ActivitiesHubPage)
  // },
  {
    path: 'partner-benefits-list',
    loadComponent: () => import('./pages/partner-benefits-list/partner-benefits-list.page').then(m => m.PartnerBenefitsListPage)
  },
  {
    path: 'renew-reactivate-membership',
    loadComponent: () => import('./pages/reactivate-membership/reactivate-membership.page').then(m => m.ReactivateMembershipPage)
  },
  {
    path: 'gift-details',
    loadComponent: () => import('./pages/gift-details/gift-details.page').then(m => m.GiftDetailsPage)
  },
 
  {
    path: 'dinning-reservation',
    loadComponent: () => import('./pages/dinning-reservation/dinning-reservation.page').then(m => m.DinningReservationPage)
  },
  {
    path: 'table-reserve',
    loadComponent: () => import('./pages/table-reserve/table-reserve.page').then(m => m.TableReservePage)
  },
  {
    path: 'redeem-benefit',
    loadComponent: () => import('./pages/redeem-benefit/redeem-benefit.page').then(m => m.RedeemBenefitPage)
  },
  {
    path: 'redeem-benefit-certificate',
    loadComponent: () => import('./pages/redeem-benefit/redeem-benefit-certificate/redeem-benefit-certificate.page').then(m => m.RedeemBenefitCertificatePage)
  },
  {
    path: 'redeem-benefit-otp',
    loadComponent: () => import('./pages/redeem-benefit/redeem-benefit-otp/redeem-benefit-otp.page').then(m => m.RedeemBenefitOtpPage)
  },
  {
    path: 'redeem-benefit-qr',
    loadComponent: () => import('./pages/redeem-benefit/redeem-benefit-qr/redeem-benefit-qr.page').then(m => m.RedeemBenefitQrPage)
  },
  {
    path: 'redeem-benefit-rating',
    loadComponent: () => import('./pages/redeem-benefit/redeem-benefit-rating/redeem-benefit-rating.page').then(m => m.RedeemBenefitRatingPage)
  },
  {
    path: 'tabs-membership',
    loadComponent: () => import('./pages/tlcComponents/tabs-membership/tabs-membership.module').then(m => m.TabsMembershipPageModule)
  },
  {
    path: 'faqs',
    loadComponent: () => import('./pages/profile/faqs/faqs.page').then(m => m.FaqsPage)
  },
  // {
  //   path: 'feedback',
  //   loadComponent: () => import('./pages/profile/feedback/feedback.page').then(m => m.FeedbackPage)
  // },
  // {
  //   path: 'contactUs',
  //   loadComponent: () => import('./pages/profile/contact-us/contact-us.page').then(m => m.ContactUsPage)
  // },
  {
    path: 'settings',
    loadComponent: () => import('./pages/profile/settings/settings.page').then(m => m.SettingsPage)
  },
  {
    path: 'updateProfile',
    loadComponent: () => import('./pages/profile/update-profile/update-profile.page').then(m => m.UpdateProfilePage)
  },
  // {
  //   path: 'notifications',
  //   loadComponent: () => import('./pages/profile/notifications/notifications.page').then(m => m.NotificationsPage)
  // },
  {
    path: 'plan-with-club',
    loadChildren: () => import('./pages/plan-with-club/plan-with-club.page').then(m => m.PlanWithClubPage)
  },
  {
    path: 'business-meeting',
    loadComponent: () => import('./pages/plan-with-club/business-meeting/business-meeting.page').then(m => m.BusinessMeetingPage)
  },
  {
    path: 'social-events',
    loadComponent: () => import('./pages/plan-with-club/social-events/social-events.page').then(m => m.SocialEventsPage)
  },
  // {
  //   path: 'personal-services',
  //   loadComponent: () => import('./pages/plan-with-club/personal-services/personal-services.page').then(m => m.PersonalServicesPage)
  // },
  // {
  //   path: 'order-in',
  //   loadComponent: () => import('./pages/plan-with-club/order-in/order-in.page').then(m => m.OrderInPage)
  // },
  // {
  //   path: 'card-detail',
  //   loadComponent: () => import('./pages/card-detail/card-detail.page').then(m => m.CardDetailPage)
  // },
 
  // {
  //   path: 'activity-description',
  //   loadComponent: () => import('./pages/plan-with-club/activities-hub/activity-description/activity-description.page').then(m => m.ActivityDescriptionPage)
  // },
  // {
  //   path: 'service-description',
  //   loadChildren: () => import('./pages/plan-with-club/personal-services/service-description/service-description.page').then(m => m.ServiceDescriptionPage)
  // },
  {
    path: 'cancel-reservation',
    loadComponent:() => import('./pages/cancel-reservation/cancel-reservation.page').then(m => m.CancelReservationPage)
  },
  // {
  //   path: 'explore-welcome',
  //   loadComponent: () => import('./pages/explore-welcome/explore-welcome.page').then(m => m.ExploreWelcomePage)
  // },
  {
    path: 'explore-hotel',
    loadComponent: () => import('./pages/explore-hotel/explore-hotel.page').then(m => m.ExploreHotelPage)
  },
  {
    path: 'activities',
    loadComponent: () => import('./pages/activities/activities.page').then(m => m.ActivitiesPage)
   
  },
  // {
  //   path: 'view-details',
  //   loadComponent: () => import('./pages/plan-with-club/order-in/view-details/view-details.page').then(m => m.ViewDetailsPage)
  // },
  {
    path: 'gift-cart',
    loadComponent: () => import('./pages/gift-certificates/gift-cart/gift-cart.page').then(m => m.GiftCartPage)
   
  },
  {
    path: 'buy-certificate-detail',
    loadComponent: () => import('./pages/buy-certificates/buy-certificate-detail/buy-certificate-detail.page').then(m => m.BuyCertificateDetailPage)
  },
  // {
  //   path: 'view-benefit',
  //   loadComponent: () => import('./pages/view-benefit/view-benefit.page').then(m => m.ViewBenefitPage)
  // },
  {
    path: 'gift-certificates-success',
    loadComponent: () => import('./pages/gift-certificates/gift-certificates-success/gift-certificates-success/gift-certificates-success.page').then(m => m.GiftCertificatesSuccessPage)

  },
  // {
  //   path: 'gift-certificates-count',
  //   loadComponent: () => import('./pages/gift-certificates/gift-certificates-count/gift-certificates-count/gift-certificates-count.page').then(m => m.GiftCertificatesCountPage)
  // },
  // {
  //   path: 'gift-certificates-count',
  //   loadComponent: () => import('./pages/gift-certificates/gift-certificates-count/gift-certificates-count/gift-certificates-count.page').then(m => m.GiftCertificatesCountPage)
  // },
  {
    path: 'membership-card-terms',
    loadComponent: () => import('./pages/membership-card-terms/membership-card-terms.page').then(m => m.MembershipCardTermsPage)
  },
  {
    path: 'experience-certificate',
    loadComponent: () => import('./pages/marriott-experience/marriott-experience.page').then(m => m.MarriottExperiencePage),
  },
  // {
  //   path: 'promo-code',
  //   loadComponent: () => import('./pages/promo-code/promo-code.page').then(m => m.PromoCodePage)
  // },
  {
    path: 'create-membership',
    loadComponent: () => import('./pages/signUp/create-membership/create-membership.page').then(m => m.CreateMembershipPage)
  },
  {
    path: 'create-membership-for-visitor',
    loadComponent: () => import('./pages/signUp/create-membership-for-visitor/create-membership-for-visitor.page').then(m => m.CreateMembershipForVisitorPage)
  },
  // {
  //   path: 'sign-up-promocode',
  //   loadComponent: () => import('./pages/signUp/sign-up-promocode/sign-up-promocode.page').then(m => m.SignUpPromocodePage)
  // },
  {
    path: 'send-invites',
    loadComponent: () => import('./pages/send-invites/send-invites.page').then(m => m.SendInvitesPage)
  },
  // { path: 'profile', loadChildren: './pages/profile/profile.module.ts#ProfilePageModule' },
  // { path: 'start-chat', loadChildren: './pages/chat/start-chat/start-chat.module#StartChatPageModule' },
  {
    path: 'cardWallet',
    component: CardWalletComponent
  },
  // {
  //   path: 'BuyAnotherMembership',
  //   component: BuyAnotherMembershipComponent
  // },
  {
    path: 'certificateCountDetail',
    component: CertificateCountDetailsComponent
  },
  {
    path: 'search-outlet-for-promotion',
    loadComponent: () => import('./pages/search-outlet-for-promotion/search-outlet-for-promotion.page').then(m => m.SearchOutletForPromotionPage)
  }, {
    path: 'promotion-details',
    loadComponent: () => import('./pages/promotion-details/promotion-details.page').then(m => m.PromotionDetailsPage)
  },
  // {
  //   path: 'mbow',
  //   loadComponent: () => import('./pages/mbow/mbow.page').then(m => m.MbowPage)
    
  // },
  // {
  //   path: 'delivery-address',
  //   loadComponent: () => import('./pages/mbow/delivery-address/delivery-address.page').then(m => m.DeliveryAddressPage)
  // },
  // Version Two for new flows
  {
    path: 'user-sign-up',
    loadComponent: () => import('./pages/versionTwo/signup/user-details/user-details.page').then(m => m.UserDetailsPage)
  },
  {
    path: 'choose-plan',
    loadComponent: () => import('./pages/versionTwo/signup/choose-plan/choose-plan.page').then(m => m.ChoosePlanPage)
  },
  {
    path: 'v2-enroll-for-property',
    loadComponent: () => import('./pages/versionTwo/signup/enroll-for-property/enroll-for-property.page').then(m => m.EnrollForPropertyPage)
  },
  {
    path: 'activate-subscription',
    loadComponent: () => import('./pages/versionTwo/activate-subscription/activate-subscription.page').then(m => m.ActivateSubscriptionPage)
  },
  // {
  //   path: 'v2-subscription',
  //   loadComponent: () => import('./pages/versionTwo/subscription/subscription.page').then(m => m.SubscriptionPage)
  // },
  // {
  //   path: 'v2-card-benefits',
  //   loadComponent: () => import('./pages/versionTwo/card-benefits/card-benefits.page').then(m => m.CardBenefitsPage)
  // },
  {
    path: 'v2-subscription-benefits',
    loadComponent: () => import('./pages/versionTwo/subscription-benefits/subscription-benefits.page').then(m => m.SubscriptionBenefitsPage)
  },
  // {
  //   path: 'v2-social-events',
  //   loadComponent: () => import('./pages/versionTwo/social-events/social-events.page').then(m => m.SocialEventsPage)
  // },
  // {
  //   path: 'v2-business-meetings',
  //   loadComponent: () => import('./pages/versionTwo/business-meetings/business-meetings.page').then(m => m.BusinessMeetingsPage)
  // },
  {
    path: 'v2-select-outlet',
    loadComponent: () => import('./pages/versionTwo/select-outlet/select-outlet.page').then(m => m.SelectOutletPage)
  },
  // {
  //   path: 'v2-outlet-detail',
  //   loadComponent: () => import('./pages/versionTwo/outlet-detail/outlet-detail.page').then(m => m.OutletDetailPage)
  // },
  // {
  //   path: 'v2-card-wallet',
  //   loadComponent: () => import('./pages/versionTwo/card-wallet/card-wallet.page').then(m => m.CardWalletPage)
  // },
  // {
  //   path: 'v2-renew-subscription',
  //   loadComponent: () => import('./pages/versionTwo/renew-subscription/renew-subscription.page').then(m => m.RenewSubscriptionPage)
  // },
  // {
  //   path: 'v2-explore-hotel',
  //   loadComponent: () => import('./pages/versionTwo/explore-hotel/explore-hotel.page').then(m => m.ExploreHotelPage)
  // },
  {
    path: 'v2-subscription-terms',
    loadComponent: () => import('./pages/versionTwo/subscription-terms/subscription-terms.page').then(m => m.SubscriptionTermsPage)
  },
  {
    path: 'benefit-details',
    loadComponent: () => import('./pages/versionTwo/subscription-terms/subscription-terms.page').then(m => m.SubscriptionTermsPage)
  },
  {
    path: 'v2-subscription-detail',
    loadComponent: () => import('./pages/versionTwo/subscription-detail/subscription-detail.page').then(m => m.SubscriptionDetailPage)
  },
  {
    path: 'enroll-for-visitor',
    loadComponent: () => import('./pages/versionTwo/signup/enroll-for-visitor/enroll-for-visitor.page').then(m => m.EnrollForVisitorPage)
  },
  {
    path: 'buy-another-subscription',
    loadComponent: () => import('./pages/versionTwo/buy-another-subscription/buy-another-subscription.page').then(m => m.BuyAnotherSubscriptionPage)
  },
  {
    path: 'enroll-subscription',
    loadComponent: () => import('./pages/versionTwo/buy-another-subscription/enroll-subscription/enroll-subscription.page').then(m => m.EnrollSubscriptionPage)
  },
  {
    path: 'gift-subsciption-screen',
    loadComponent: () => import('./pages/versionTwo/gift-subsciption/gift-subsciption-screen/gift-subsciption-screen.page').then(m => m.GiftSubsciptionScreenPage)
  },
  {
    path: 'enroll-gift-subscription',
    loadComponent: () => import('./pages/versionTwo/gift-subsciption/gift-subsciption-screen/enroll-gift-subscription/enroll-gift-subscription.page').then(m => m.EnrollGiftSubscriptionPage)
  },
  // {
  //   path: 'gift-subscription-detail',
  //   loadComponent: () => import('./pages/versionTwo/gift-subsciption/gift-subsciption-screen/gift-subscription-detail/gift-subscription-detail.page').then(m => m.GiftSubscriptionDetailPage)
  // },

  //cc_avenue task

   {
  path: 'gift-subscription-detail',
  children: [
    {
      path: '',
     loadComponent: () =>
        import('./pages/versionTwo/gift-subsciption/gift-subsciption-screen/gift-subscription-detail/gift-subscription-detail.page').then(
          (m) => m.GiftSubscriptionDetailPage
        ),
    },
    {
      path: 'success.json',
      loadComponent: () =>
        import('./pages/versionTwo/gift-subsciption/gift-subsciption-screen/gift-subscription-detail/gift-subscription-detail.page').then(
          (m) => m.GiftSubscriptionDetailPage
        ),
    },
  ],
},


  // {
  //   path: 'redeem-membership-benefits',
  //   loadChildren: () => import('./pages/versionTwo/membership-benefits/membership-benefits.module').then(m => m.MembershipBenefitsPageModule)
  // },
  {
    path: 'select-plan',
    loadComponent: () => import('./pages/versionTwo/signup/select-plan/select-plan.page').then(m => m.SelectPlanPage)
  },
   {
    path: 'hotel-specific-membership',
    children: [
      {
        path: '',
         loadComponent: () =>
          import('./pages/versionTwo/signup/hotel-specific-membership/hotel-specific-membership.page').then(
            (m) => m.HotelSpecificMembershipPage
          ),
      },
      {
        path: 'success.json',
        loadComponent: () =>
          import('./pages/versionTwo/signup/hotel-specific-membership/hotel-specific-membership.page').then(
            (m) => m.HotelSpecificMembershipPage
          ),
      }
    ]

    // loadChildren: () => import('./pages/versionTwo/signup/hotel-specific-membership/hotel-specific-membership.module').then(m => m.HotelSpecificMembershipPageModule)
  },
  {
    path: 'buy-another/hotel-specific-membership',
    children: [
      {
        path: '',
       loadComponent: () =>
          import('./pages/versionTwo/buy-another-subscription/hotel-specific-membership/hotel-specific-membership.page').then(
            (m) => m.HotelSpecificMembershipPage
          ),
      },
      {
        path: 'success.json',
        loadComponent: () =>
          import('./pages/versionTwo/buy-another-subscription/hotel-specific-membership/hotel-specific-membership.page').then(
            (m) => m.HotelSpecificMembershipPage
          ),
      }
    ]

    // loadChildren: () => import('./pages/versionTwo/buy-another-subscription/hotel-specific-membership/hotel-specific-membership.module').then(m => m.HotelSpecificMembershipPageModule)
  },
  {
    path: 'select-plan-buy-another',
    loadComponent: () => import('./pages/versionTwo/buy-another-subscription/select-plan/select-plan.page').then(m => m.SelectPlanPage)
  },
  // {
  //   path: 'select-plan-gift',
  //   loadComponent: () => import('./pages/versionTwo/gift-subsciption/select-plan/select-plan.page').then(m => m.SelectPlanPage)
  // },
  {
    path: 'hotel-specific-gift',
    loadComponent: () => import('./pages/versionTwo/gift-subsciption/hotel-specific-gift/hotel-specific-gift.page').then(m => m.HotelSpecificGiftPage)
  },
  {
    path: 'terms-conditions',
    loadComponent: () => import('./pages/terms-and-condition/terms-and-condition.page').then(m => m.TermsAndConditionPage)
  },
  // {
  //   path: 'lead-form-confirmation',
  //   loadComponent: () => import('./pages/lead-form-confirmation/lead-form-confirmation.page').then(m => m.LeadFormConfirmationPage)
  // },
  {
    path: 'partner-promotions',
    loadComponent: () => import('./pages/partner-promotions/partner-promotions.page').then(m => m.PartnerPromotionsPage)
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./pages/terms-of-use/terms-of-use.page').then(m => m.TermsOfUsePage)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./pages/contact-us/contact-us.page').then(m => m.ContactUsPage)
  },
  {
    path: 'payment-terms',
    loadComponent: () => import('./pages/payment-terms/payment-terms.page').then(m => m.PaymentTermsPage)
  },
  {
    path: 'fav-property',
    loadComponent:() => import('./pages/fav-property/fav-property.page').then(m => m.FavPropertyPage)
  },
  {
    path: 'disclaimer',
    loadComponent: () => import('./pages/disclaimer/disclaimer.page').then(m => m.DisclaimerPage)
  },
  {
    path: 'page-not-found',
    loadComponent: () => import('./pages/page-not-found/page-not-found.page').then(m => m.PageNotFoundPage)
  },
  {
    path: 'participating-hotels',
    loadComponent: () => import('./pages/participating-hotels/participating-hotels.page').then(m => m.ParticipatingHotelsPage)
  },
  {
    path: 'property/:city/:propertyName',
    loadComponent: () => import('./pages/property/property.page').then(m => m.PropertyPage), 
  }, 
  {
    path: ':propertyName/promotion/:promotionName/:id',
    loadComponent: () => import('./pages/promotion/promotion.page').then(m => m.PromotionPage)
  },
  {
    path: 'promotion/:promotionName',
    loadComponent: () => import('./pages/promotion/promotion.page').then(m => m.PromotionPage)
  },
  // {
  //   path: 'landing',
  //   loadComponent: () => import('./pages/landing/landing.page').then(m => m.LandingPage), //not used in current project
  // },

  {
    path: 'benefits',
    loadComponent:() => import('./pages/benefits/benefits.page').then(m => m.BenefitsPage)
  },
  // {
  //   path: 'subscriptions',
  //   loadComponent: () => import('./pages/subscriptions/subscriptions.page').then(m => m.SubscriptionsPage)
  // },
  // {
  //   path: 'subscription-details',
  //   loadComponent: () => import('./pages/subscription-details/subscription-details.page').then(m => m.SubscriptionDetailsPage)
  // },
  // {
  //   path: 'mobile-app',
  //   loadComponent: () => import('./pages/mobile-app/mobile-app.page').then(m => m.MobileAppPage)

  // },
  // {
  //   path: 'app-tour',
  //   loadComponent:() => import('./pages/app-tour/app-tour.page').then(m => m.AppTourPage)
  
  // },
  {
    path: 'experience-detail',
    loadComponent: () => import('./pages/experience-detail/experience-detail.page').then( m => m.ExperienceDetailPage)
  },
  {
    path: 'receive-benfit-otp',
    loadComponent: () => import('./pages/receive-benfit-otp/receive-benfit-otp.page').then(m => m.ReceiveBenfitOtpPage)
  },
  {
    path: 'sitemap',
    loadComponent: () => import('./pages/sitemap/sitemap.page').then( m => m.SitemapPage)
  },
  {
    path: 'confirm-details',
    loadComponent: () => import('./pages/confirm-details/confirm-details.page').then( m => m.ConfirmDetailsPage)

  },
  {
    path: 'membership-enrollment-page',
    loadComponent: () => import('./pages/confirm-details/confirm-details.page').then( m => m.ConfirmDetailsPage)
  },
//   {
//     path: 'sbic-aurum',
//     loadComponent: () => import('./pages/white-reserve/white-reserve.page').then( m => m.WhiteReservePage)
//   },
//  {
//     path: 'kotak-white-reserve',
//     loadComponent: () => import('./pages/white-reserve/white-reserve.page').then( m => m.WhiteReservePage)
//   },
//   {
//     path: 'diners',
//     loadComponent: () => import('./pages/white-reserve/white-reserve.page').then( m => m.WhiteReservePage)
//   },
//   {
//     path: 'indusind-bank',
//     loadComponent: () => import('./pages/white-reserve/white-reserve.page').then( m => m.WhiteReservePage)
//   },
//   {
//     path: 'powermiles',
//     loadComponent: () => import('./pages/white-reserve/white-reserve.page').then( m => m.WhiteReservePage)
//   },
  // {
  //   path: 'reserve-success',
  //   loadComponent: () => import('./pages/reserve-success/reserve-success.page').then( m => m.ReserveSuccessPage)
  // },
  // {
  //   path: 'participating-spa',
  //   loadComponent: () => import('./pages/participating-spa/participating-spa.page').then( m => m.ParticipatingSpaPage)
  // },
  // {
  //   path: 'benefit-terms',
  //   loadComponent:() => import('./pages/benefit-terms/benefit-terms.page').then( m => m.BenefitTermsPage)
  // },
  // {
  //   path: 'members-day',
  //   loadComponent: () => import('./pages/participating-outlets/participating-outlets.page').then( m => m.ParticipatingOutletsPage)
  // },
  // {
  //   path: 'all-day-dining-restaurants',
  //   loadComponent: () => import('./pages/participating-outlets/participating-outlets.page').then( m => m.ParticipatingOutletsPage)
  // },
  // {
  //   path: 'bars',
  //   loadComponent: () => import('./pages/participating-outlets/participating-outlets.page').then( m => m.ParticipatingOutletsPage)
  // },
  {
  path: 'tabs/membership/certificateHistory',
  loadComponent: () => import('./pages/tlcComponents/tabs-membership/certificate-history/certificate-history.component').then(m => m.CertificateHistoryComponent)
},
 {
    path: 'black',
    loadComponent: () => import('./pages/black-card-content/black-card-content.page').then( m => m.BlackCardContentPage)
  },
  {
  path: 'wallet-link',
  loadComponent: () =>
    import('./pages/wallet-link/wallet-link.page').then(m => m.WalletLinkPage),
  canActivate: [AuthGuard]
},
{
  path: 'wallet-link/:id',
  loadComponent: () =>
    import('./pages/wallet-link/wallet-link.page').then(m => m.WalletLinkPage),
  canActivate: [AuthGuard]
},
 {
    path: '**',
    redirectTo: 'page-not-found'
  },
  

  
];
